import React, { useState } from "react";
import { IoEyeOff, IoEye } from "react-icons/io5";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { getAllUsers, saveNewUser } from "../store/actions/user";
import { useNavigate } from "react-router-dom";
import { IoArrowBack } from "react-icons/io5";

const UserManagementAdd = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [filterQuery, setFilterQuery] = useState({
    limit: "10",
    page: "1",
  });

  const togglePasswordVisibility = () => setShowPassword(!showPassword);

  // redux logic
  const users = useSelector((state) => state.users);

  const getUserList = () => {
    dispatch(getAllUsers(filterQuery));
  };

  const handleSaveUser = async (e) => {
    e.preventDefault();
    setIsSubmitting(true); // Disable the button and lock the UI

    try {
      await dispatch(
        saveNewUser({
          username: e.target.username.value,
          email: e.target.email.value,
          password: e.target.password.value,
          createdSource: "Admin",
        })
      );

      toast.success("User created successfully!", {
        position: "top-right",
        autoClose: 600,
        onClose: () => {
          getUserList();
        },
      });
    } catch (error) {
      toast.error("Failed to create user. Please try again.", {
        position: "top-right",
        autoClose: 600,
      });
    } finally {
      setIsSubmitting(false); // Re-enable the button
    }
  };

  return (
    <div className="relative bg-[#cbd5e0]">
      <div className=" bg-top p-2  fixed  w-full lg:max-w-[calc(100%-16rem)] z-10 bg-slate-200">
        <div className="w-full flex items-center justify-between p-1  gap-4">
          <div className="text-text text-lg font-medium">Add New User</div>
          <button
            type="button"
            className="flex items-center text-[#02256d] hover:text-[#fdbc12] hover:underline rounded-lg text-base"
            onClick={() => navigate(-1)} // Go back to the previous page
          >
            <IoArrowBack className="mr-2 w-5 h-5" /> {/* Icon with margin */}
            Go Back
          </button>
        </div>
      </div>
      <div className="flex bg-card mx-2 justify-center items-center lg:h-[95vh] bg-[#cbd5e0]">
        <div className="lg:w-[70%] m-2 bg-background rounded-lg shadow dark:bg-gray-700 bg-slate-200">
          {/* Modal Header */}
          <div className="flex items-center justify-between p-4 md:p-5 border-b rounded-t  dark:border-gray-600">
            <h3 className="text-lg font-medium text-gray-900 dark:text-white">
              Add New User
            </h3>
          </div>

          <form className="p-4 md:p-5" onSubmit={handleSaveUser}>
            <div className="grid gap-4 mb-4 grid-cols-1">
              <div>
                <label
                  htmlFor="username"
                  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                >
                  Username
                </label>
                <input
                  type="text"
                  id="username"
                  name="username"
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                  placeholder="Enter your username"
                  required
                  disabled={isSubmitting} // Disable input during submission
                />
              </div>

              <div>
                <label
                  htmlFor="email"
                  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                >
                  Email
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                  placeholder="Enter your email"
                  required
                  disabled={isSubmitting} // Disable input during submission
                />
              </div>

              <div>
                <label
                  htmlFor="password"
                  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                >
                  Password
                </label>
                <div className="relative">
                  <input
                    type={showPassword ? "text" : "password"}
                    id="password"
                    name="password"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                    placeholder="Enter your password"
                    required
                    disabled={isSubmitting} // Disable input during submission
                  />
                  <button
                    type="button"
                    onClick={togglePasswordVisibility}
                    className="absolute inset-y-0 right-0 flex items-center pr-3"
                    disabled={isSubmitting} // Disable button during submission
                  >
                    {showPassword ? (
                      <IoEye className="w-5 h-5 text-gray-500" />
                    ) : (
                      <IoEyeOff className="w-5 h-5 text-gray-500" />
                    )}
                  </button>
                </div>
              </div>
            </div>

            <button
              type="submit"
              disabled={isSubmitting} // Disable button during submission
              className={`w-full justify-center text-white inline-flex items-center ${
                isSubmitting
                  ? "bg-gray-500 cursor-not-allowed"
                  : "bg-[#02256d] hover:bg-blue-800"
              } focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800`}
            >
              {isSubmitting ? "Saving..." : "Save"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default UserManagementAdd;
